const couponcheck = () => import('../views/couponsys/couponcheck')
const savethetrees = () => import('../views/couponsys/savethetrees')
const dreamanddream = () => import('../views/couponsys/dreamanddream')
const queenti = () => import('../views/couponsys/queenti')

export default [
  {
    path: '/cp/couponcheck/:couponNo',
    name: '/cp/couponcheck',
    component: couponcheck
  },
  {
    path: '/cp/savethetrees',
    name: '/cp/savethetrees',
    component: savethetrees,
    props: true
  },
  {
    path: '/cp/dreamanddream',
    name: '/cp/dreamanddream',
    component: dreamanddream,
    props: true
  },
  {
    path: '/cp/queenti',
    name: '/cp/queenti',
    component: queenti,
    props: true
  }
]